// Angular Core Imports
import { Component, Input, OnInit } from '@angular/core';

// Model and Service Imports
import { Client } from '../../../../core/models/client';
import { RadioBtnComponent } from '../../../../shared/radio-btn/radio-btn.component';


@Component({
    selector: 'app-client-feature-config',
    templateUrl: './client-feature-config.component.html',
    styleUrls: ['./client-feature-config.component.scss'],
    standalone: true,
    imports: [RadioBtnComponent]
})
export class ClientFeatureConfigComponent implements OnInit {
  @Input() client: Client;

  constructor() { }

  ngOnInit() {
  }

}
